import { render, staticRenderFns } from "./BusinessesInformation.vue?vue&type=template&id=331e5430&scoped=true&"
import script from "./BusinessesInformation.vue?vue&type=script&lang=js&"
export * from "./BusinessesInformation.vue?vue&type=script&lang=js&"
import style0 from "./BusinessesInformation.vue?vue&type=style&index=0&id=331e5430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e5430",
  null
  
)

export default component.exports